import { faker } from '@faker-js/faker';
import { delay, http, HttpResponse } from 'msw';

export const handlers = [
  http.get(
    '*/api/js/ap_office_member_report_notification_setting',
    async () => {
      await delay(1000);
      return new HttpResponse(
        JSON.stringify(getGetApOfficeMemberReportNotificationSettingMock()),
        {
          status: 200,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
    }
  ),
  http.patch(
    '*/api/js/ap_office_member_report_notification_setting',
    async () => {
      await delay(1000);
      return new HttpResponse(
        JSON.stringify(getUpdateApOfficeMemberReportNotificationSettingMock()),
        {
          status: 200,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
    }
  ),
];

export const getGetApOfficeMemberReportNotificationSettingMock = () => ({
  workflow: {
    is_active: faker.datatype.boolean(),
    only_final_approval: faker.datatype.boolean(),
  },
  report_timeline: { is_active: faker.datatype.boolean() },
  approvable_report: { is_active: faker.datatype.boolean() },
});

export const getUpdateApOfficeMemberReportNotificationSettingMock = () => ({
  workflow: {
    is_active: faker.datatype.boolean(),
    only_final_approval: faker.datatype.boolean(),
  },
  report_timeline: { is_active: faker.datatype.boolean() },
  approvable_report: { is_active: faker.datatype.boolean() },
});
